import { render, staticRenderFns } from "./CategoryPill.vue?vue&type=template&id=c661fda2&"
import script from "./CategoryPill.vue?vue&type=script&lang=js&"
export * from "./CategoryPill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports